import { render, staticRenderFns } from "./InsufficientResources.vue?vue&type=template&id=5484cb8e&scoped=true"
import script from "./InsufficientResources.vue?vue&type=script&lang=js"
export * from "./InsufficientResources.vue?vue&type=script&lang=js"
import style0 from "./InsufficientResources.vue?vue&type=style&index=0&id=5484cb8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5484cb8e",
  null
  
)

export default component.exports